import classNames from 'classnames'

const variants = {
  primary:
    'bg-[#5754E5] cursor-pointer ',
  secondary: [
    'font-medium bg-blue-600 text-black hover:bg-white hover:outline-none hover:text-white focus:ring-grey-600 ',
  ],
  disabled:
    'bg-[#D1D1FF] cursor-not-allowed   ',
 
}

const sizes = {
  sm: ' w-8 h-12',
  md: 'h-12 w-64	text-lg',
  lg: 'h-14 w-64 text-xl',
  xl: 'h-12 w-96 text-xl',
}

const Button = ({
  variant,
  size = 'md',
  icon,
  children,
  className,
  ...rest
}) => {
  const classes = classNames(
    ' focus:outline-none focus:ring-0  w-full h-[56px] rounded-[16px] text-[16px] font-bold rounded-5 text-white ',
    'flex flex-row items-center justify-center space-x-2 ',
    variant && variants[variant],
    sizes[size],
    className,
  )
  return (
    <button className={classes} {...rest}>
      {icon && <img src={icon} alt="" className="mr-2" />}
      {children}
    </button>
  )
}

export default Button
